.tile {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.accent {
  background: var(--navy);
  border-color: #1e2a3d;
  color: #e6eaf0;
}
.accent .label,
.accent .hint {
  color: #9aa5b8;
}
.accent .icon {
  background: #1e2a3d;
  color: var(--amber);
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.label {
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-text-muted);
}
.icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-sm);
  background: var(--color-accent-soft);
  color: var(--color-accent-ink);
  display: grid;
  place-items: center;
  flex: none;
}
.value {
  font-family: var(--font-display);
  font-size: 2.1rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.15;
}
.foot {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
  font-size: var(--text-xs);
}
.delta {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-weight: 700;
}
.good {
  color: var(--color-success);
}
.bad {
  color: var(--color-danger);
}
.hint {
  color: var(--color-text-subtle);
}
